import React from "react";
import PropTypes from "prop-types";
import { Card, Select, Divider, DatePicker, Modal, Tag } from "antd";
import { Table } from "components";
import { OrderedMap, List } from "immutable";
import { PermissionContextManager } from "hocs";
import XLSXDownloader from "components/xls-downloader";
import { formatCurrencyWithLabels } from "utilities/currency";
import { STATE_STATUS } from "../../constants";
import { UI_PERMISSIONS } from "constants/index";
import {
    SALES_ANALYSIS_DISPLAY_YEAR,
    SALES_ANALYSIS_DISPLAY_CURRENCY
} from "constants/enums";
import _startCase from "lodash/startCase";
import CaseService from "services/case-service";
import moment from "moment";
const SALES_ANALYSIS_TABLE_COLS = new OrderedMap({
    year: {
        title: "Year",
        dataIndex: "year",
        key: "year",
        width: 100,
        // fixed: "left",
        render: _ => _
    },
    total_sales: {
        title: "Total Sales",
        dataIndex: "total_sales",
        key: "total_sales",
        // fixed: "left",
        width: 150,
        // eslint-disable-next-line react/display-name
        render: _ => (<b>{+_ ? formatCurrencyWithLabels(_, "IN LACS") : "--"}</b>)
    }
});

const CurrencyOptions = SALES_ANALYSIS_DISPLAY_CURRENCY.map((v, k) => ({
    title: k,
    key: String(v)
}));
// new OrderedMap({
//     in_lacs: {
//         title: "In Lacs",
//         dataIndex: "in_lacs",
//         key: "in_lacs"
//     },
//     in_cr: {
//         title: "In Cr",
//         dataIndex: "in_cr",
//         key: "in_cr"
//     },
//     no_label: {
//         title: "Full Number",
//         dataIndex: "no_label",
//         key: "no_label"
//     }
// });

const tradeMonthColGenerator = (month, currencySelected) => ({
    title: month,
    dataIndex: month,
    key: month,
    render: _ => (+_ ? formatCurrencyWithLabels(_, currencySelected) : "--"),
    width: 100
});

const CurrencySelector = props => (
    <Select value={props.value} onSelect={props.onSelect}>
        {CurrencyOptions.map(_ => (
            <Select.Option key={_.key} value={_.key}>
                {_.title}
            </Select.Option>
        ))
            .toList()
            .toJS()}
    </Select>
);
CurrencySelector.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.string
};

const YearTypeSelector = props => (
    <Select
        value={props.value}
        onSelect={props.onSelect}
        disabled={props.disabled}
    >
        {SALES_ANALYSIS_DISPLAY_YEAR.map((v, k) => (
            <Select.Option key={v} value={String(v)}>
                {k}
            </Select.Option>
        ))
            .toList()
            .toArray()}
    </Select>
);

YearTypeSelector.propTypes = {
    onSelect: PropTypes.func,
    value: PropTypes.string,
    disabled: PropTypes.bool
};

class SalesAnalysisTradeYearTable extends React.Component {
    state = {
        loading: false,
        data: new List([]),
        yearType: "0",
        currencySelected: "in_lacs",
        openDateRangeModal: false,
        startDate: "",
        endDate: "",
        showRequiredError: false,
        tagFromDate: "",
        tagToDate: ""
    };
    tableCols = SALES_ANALYSIS_TABLE_COLS;
    componentDidMount() {
        this.handleDataFetch(this.props);
        CaseService.getCaseLedgerDate(this.props.caseId).then((data) => {
            this.setState({
                tagFromDate: data.data.supplychain_filter_from_date,
                tagToDate: data.data.supplychain_filter_to_date
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        this.handleDataFetch(nextProps);
    }

    handleDataFetch = props => {
        if (
            !props.financialsStatus ||
            props.financialsStatus === STATE_STATUS.UNFETCHED
        ) {
            props.fetch(props.caseId);
        } else if (
            this.state.data.size === 0 &&
            props.financialsStatus === STATE_STATUS.FETCHED
        ) {
            this.createTableCols(
                props.financials.getCols(Number(this.props.displayYear))
            );
            this.setState({
                data: props.financials.getRows(Number(this.props.displayYear)),
                loading: false
            });
        }
    };
    handleSave = () => {};
    onYearSelect = yearType => {
        // this.tableCols = SALES_ANALYSIS_TABLE_COLS.set("total_sales", {
        //     ...SALES_ANALYSIS_TABLE_COLS.get("total_sales"),
        //     render: _ =>
        //         +_
        //             ? formatCurrencyWithLabels(_, this.props.displayCurrency)
        //             : "--"
        // });
        // this.createTableCols(this.props.financials.getCols(Number(yearType)));
        // this.setState({
        //     yearType,
        //     data: this.props.financials.getRows(Number(yearType)),
        //     loading: false
        // });
        this.props.onSalesDisplayChange(yearType, this.props.displayCurrency);
    };

    onCurrencySelect = selectedCurrency => {
        // this.tableCols = SALES_ANALYSIS_TABLE_COLS.set("total_sales", {
        //     ...SALES_ANALYSIS_TABLE_COLS.get("total_sales"),
        //     render: _ =>
        //         +_ ? formatCurrencyWithLabels(_, selectedCurrency) : "--"
        // });
        // this.setState(
        //     {
        //         currencySelected: selectedCurrency
        //     },
        //     () => {
        //         this.forceUpdate();
        //         this.createTableCols(
        //             this.props.financials.getCols(Number(this.state.yearType))
        //         );
        //     }
        // );
        this.props.onSalesDisplayChange(
            this.props.displayYear,
            selectedCurrency
        );
    };

    tableCols = SALES_ANALYSIS_TABLE_COLS.set("total_sales", {
        ...SALES_ANALYSIS_TABLE_COLS.get("total_sales"),
        render: _ =>
            +_
                ? <b>{formatCurrencyWithLabels(
                    _,
                    SALES_ANALYSIS_DISPLAY_CURRENCY.findKey(
                        __ => __ === +this.props.displayCurrency
                    )
                )}</b>
                : "--"
    });
    createTableCols = cols => {
        cols &&
            cols.map(_ =>
                !["year", "total_sales"].includes(_)
                    ? (this.tableCols = this.tableCols.set(
                        _,
                        tradeMonthColGenerator(
                            _,
                            SALES_ANALYSIS_DISPLAY_CURRENCY.findKey(
                                __ => __ === +this.props.displayCurrency
                            )
                        )
                    ))
                    : null
            );
    };

    toggleDateRangeModal = () => {
        this.setState({
            openDateRangeModal: !this.state.openDateRangeModal
        });
    }

    selectStartDateRange = (date, dateString) => {
        this.setState({
            startDate: dateString,
            showRequiredError: false
        }, console.log(date));
    }

    selectEndDateRange = (date, dateString) => {
        this.setState({
            endDate: dateString
        }, console.log(date));
    }

    filterDateRangeLedger = () => {
        if(!this.state.startDate){
            this.setState({
                showRequiredError: true
            });
        } else {
            let data = {
                "supplychain_filter_from_date": this.state.startDate,
                "supplychain_filter_to_date": this.state.endDate === "" ? undefined : this.state.endDate
            };
            CaseService.updateCaseLedgerDate(this.props.caseId, data).then(() => {
                CaseService.getCaseLedgerDate(this.props.caseId).then((data) => {
                    this.setState({
                        tagFromDate: data.data.supplychain_filter_from_date,
                        tagToDate: data.data.supplychain_filter_to_date
                    });
                });
                this.props.fetch(this.props.caseId);
                this.props.callApis();
                this.toggleDateRangeModal();
            });
        }
    }

    disabledFutureDate = (current) => {
        return current && current > moment().endOf("day");
    }

    render() {
        return (
            <React.Fragment key={"parent"}>
                <Modal
                    title={"Adjust Ledgers"}
                    visible={this.state.openDateRangeModal}
                    closable={false}
                    onOk={this.filterDateRangeLedger}
                    onCancel={this.toggleDateRangeModal}
                    width={"300px"}
                >   
                    <div className={"p-10"}>
                        {this.state.showRequiredError ? <span style={{color: "red", fontSize: "12px"}}>Please select from date</span> : null}
                        <div>
                            <DatePicker disabledDate={this.disabledFutureDate} onChange={this.selectStartDateRange} placeholder="From Date" />
                        </div>
                        <div style={{marginTop: "20px"}}>
                            <DatePicker disabledDate={this.disabledFutureDate} onChange={this.selectEndDateRange} placeholder="To Date" />
                        </div>
                    </div>
                    
                </Modal>
                <Card
                    small={"size"}
                    className={"padless-card no-border-transparent flex-row-extra"}
                    // title={"Sales Analysis"}
                    extra={[
                        <React.Fragment key={"extra"}>
                            {this.props.SUPPLY_CHAIN_EDIT || 
                                this.props.isUserAllowedToEdit ? (
                                    <React.Fragment>
                                        <Tag 
                                            style={{
                                                cursor: "pointer",
                                                marginLeft: "10px",
                                                paddingTop: "5px"
                                            }} 
                                            onClick={this.toggleDateRangeModal} 
                                            key={"selected-dates"} 
                                            color="cyan"
                                        >
                                            {
                                                this.state.tagFromDate || this.state.tagToDate ?
                                                    <span>Adjusted Sales {this.state.tagFromDate}  {this.state.tagToDate ? <span>|| {this.state.tagToDate}</span> : null }</span>
                                                    : "Change Period"
                                            }
                                        </Tag>
                                        <XLSXDownloader
                                            cols={this.tableCols}
                                            data={this.state.data}
                                        />
                                        <Divider type={"vertical"} />
                                        <YearTypeSelector
                                            key={"year-selector"}
                                            value={this.props.displayYear}
                                            onSelect={this.onYearSelect}
                                            disabled={this.props.salesDisplayDisabled}
                                        />
                                        <Divider type={"vertical"} />
                                        <CurrencySelector
                                            key={"curr-selector"}
                                            value={this.props.displayCurrency}
                                            onSelect={this.onCurrencySelect}
                                        />
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <XLSXDownloader
                                            cols={this.tableCols}
                                            data={this.state.data}
                                            height={"25px"}
                                        />
                                        <Divider type={"vertical"} />
                                        <h4 key={"year-type"}>
                                            {_startCase(SALES_ANALYSIS_DISPLAY_YEAR.findKey(_ => {
                                                return _ == this.props.displayYear;
                                            }).toLowerCase())}
                                            {"        "}
                                            {`(Amount is in ${_startCase(SALES_ANALYSIS_DISPLAY_CURRENCY.findKey(_ => {
                                                return _ == this.props.displayCurrency;
                                            }).toLowerCase())})`}
                                        </h4>
                                    </React.Fragment>
                                )}
                        </React.Fragment>
                    ]}
                >
                    <Table
                        size={"small"}
                        columns={this.tableCols}
                        checkedColumns={[]}
                        data={this.state.data}
                        showTitle={false}
                        showTopSection={false}
                        pagination={false}
                        keyFilter={"id"}
                        loading={this.state.loading}
                        editable={true}
                        noRowSelection={true}
                        bordered={false}
                    />
                </Card>
            </React.Fragment>
        );
        // return <Table />;
    }
}

SalesAnalysisTradeYearTable.propTypes = {
    financials: PropTypes.object,
    financialsStatus: PropTypes.string,
    fetch: PropTypes.func,
    caseId: PropTypes.number,
    permission: PropTypes.string,
    displayYear: PropTypes.string,
    displayCurrency: PropTypes.string,
    onSalesDisplayChange: PropTypes.func,
    salesDisplayDisabled: PropTypes.bool,
    permissionContext: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool,
    SUPPLY_CHAIN_EDIT: PropTypes.bool,
    callApis: PropTypes.func
};

SalesAnalysisTradeYearTable.defaultProps = {
    displayYear: 1,
    displayCurrency: 2
};

SalesAnalysisTradeYearTable.defaultProps = {
    salesDisplayDisabled: false
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.SUPPLY_CHAIN_VIEW,
    propsPermissions: {
        SUPPLY_CHAIN_EDIT: UI_PERMISSIONS.SUPPLY_CHAIN_EDIT
    }
})(SalesAnalysisTradeYearTable);
